import {Component, HostListener, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {OauthService} from 'mclane-webauth-lib';
import {LoggingService} from 'mclane-apptemplate-lib';


@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss']
})

export class HomeComponent implements OnInit {
    deferredPrompt: any;
    showButton = false;
    applications = [];
    events = [];
    loginExtended: any;

    constructor(
                public oauthService: OauthService,
                public router: Router,
                public console: LoggingService) {

    }

    ngOnInit() {
        if (this.oauthService.isLoggedIn()) {
            this.router.navigateByUrl('/dashboard').then();
        }
    }

    @HostListener('window:beforeinstallprompt', ['$event'])
    onbeforeinstallprompt(e) {
        this.console.log(e);
        // Prevent Chrome 67 and earlier from automatically showing the prompt
        e.preventDefault();
        // Stash the event so it can be triggered later.
        this.deferredPrompt = e;
        this.showButton = true;
    }

    login() {
        const hint = this.oauthService.tryGetIdpCookie();
        this.oauthService.loginExtended({idpHint: hint}).then((item) => {
            this.console.log(item);
        });
    }
}

